import { css } from '@emotion/react';

const styles = {
  root: css`
    position: relative;
  `,
};

export type CardOnFileContainerProps = React.PropsWithChildren<{
  className?: string;
}>;

export const CardOnFileContainer = ({ className, children }: CardOnFileContainerProps) => {
  return (
    <div className={className} css={styles.root}>
      {children}
    </div>
  );
};
